import React, { useEffect, useRef } from "react";
import { Box, Typography, TextField, Button, Container, Grid,IconButton, Link, MenuItem, Divider } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import gsap from "gsap";
import { footerbg, kollalogowhite, footerpattern } from "../../../assets"; // Your assets
import {Facebook, Instagram, WhatsApp, Twitter, YouTube ,Info, Business, Contacts, LinkedIn } from "@mui/icons-material";
import { LocationOn, Email, Phone } from "@mui/icons-material";
import XIcon from '@mui/icons-material/X';
import { createLead } from "../../../api/services"; // API Service
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Close, Person,  } from "@mui/icons-material";
import { Select, FormControl } from "@mui/material";
import { TbPhoneCall } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';



const floatingAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
`;

// Footer Background Container with Opacity
const FooterContainer = styled(Box)({
    position: "relative",
    color: "white",
    padding: "60px 20px",
    left: 0,
    backgroundImage: `url(https://dprstorage.b-cdn.net/kolla/backgrounds/Kolla%20ELEVATION%20NIGHT2%20-05.png)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed", // Fixed background for parallax effect
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.6)", // Dark overlay for readability
      backdropFilter: "blur(10px)", // Blur effect for luxury feel
      zIndex: 1,
    },
  });

// Floating Box with Background & Overlay
const BackgroundContainer = styled(Box)({
  position: "relative",
    display: "flex",
  alignItems: "start",
  justifyContent: "start",
});

const InputIcon = styled(Box)({
  position: "absolute",
  left: "16px",
  top: "50%",
  transform: "translateY(-50%)",
  color: "#9f8054",
  fontSize: "22px",
  display: "flex",
  alignItems: "center",
});
const InputContainer = styled(Box)({
  position: "relative",
  width: "80%",
  marginBottom: "18px",
  display: "flex",
  alignItems: "center",
});

const StyledInput = styled(TextField)({
  width: "100%",
  height: "45px",
  backgroundColor: "transparent",
  border: "1px solid rgba(255, 255, 255, 0.6)",
  borderRadius: "25px",
  color: "white",
  fontSize: "16px",
  paddingLeft: "5px",
  "& input": {
    paddingLeft: "50px",
    height: "10px",
    color: "white",
    border: "none",
  },
  "& .MuiOutlinedInput-root": {
    padding: "0px",
    "& fieldset": {
      border: "none",
      width: "100%",
      height: "45px",
      backgroundColor: "transparent",
    },
    "&:hover fieldset": {
      border: "none",
      width: "100%",
      height: "45px",
      backgroundColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      border: "none",
      width: "100%",
      height: "45px",
      backgroundColor: "transparent",
    },
  },
});

const StyledSelect = styled(Select)({
  width: "100%",
  height: "45px",
  backgroundColor: "transparent",
  borderRadius: "25px",
  color: "white",
  fontSize: "16px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.6) !important",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#9f8054 !important",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#9f8054 !important",
    boxShadow: "0px 4px 10px rgba(159, 128, 84, 0.6)",
  },
});


// Floating Logo
const FloatingImage = styled("img")({
  width: 100,
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  transition: "transform 0.3s ease-in-out",
  zIndex: 2,

  "&:hover": {
    transform: "translate(-50%, -50%) scale(1.1)",
  },
});

// Animated Description Below Box
const AnimatedText = styled(Typography)({
  color: "#fff",
  fontSize: "14px",
  textAlign: "center",
  marginTop: 10,
  opacity: 1, // Initially hidden for GSAP animation
  zIndex: 3,
});





// Quick Links Data with Icons
const quickLinks = [
    { title: "Home", url: "https://www.kollagroup.com/", icon: <LocationOn /> },
    { title: "Luxor Exclusive", url: "https://www.kollagroup.com/luxor-exclusive", icon:<Business />  },
    { title: "Luxuria", url: "https://www.kollagroup.com/luxuria", icon:<Business /> },
    { title: "Contact Us", url: "https://www.kollagroup.com/contactus", icon: <Contacts /> },
    // { title: "Blog", url: "https://www.kollagroup.com/blog", icon: <Contacts /> },
  ];
  
  // Quick Links Container
  const QuickLinksContainer = styled(Box)({
    textAlign: "start",
    opacity: 1,
  });
  
  // Quick Links Styling with Hover Animation
  const QuickLink = styled(Link)({
    color: "white",
    textDecoration: "none",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    margin: "8px 0",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
      color: "#ff914d",
      textDecoration: "underline",
    },
  });

  

// Form Container on Right Side
const FormContainer = styled(Box)(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.1)",
  padding: "10px",
  borderRadius: "10px",
  boxShadow: "0px 5px 15px rgba(0,0,0,0.3)",
  maxWidth: "370px",
  width: "100%",
  textAlign: "center",
  opacity: 1, // Initially hidden
  transform: "translateX(50px)",
  zIndex: 3,
  backdropFilter: "blur(18px)", // Blur effect for luxury feel
  display: "flex",
  alignItems: "center",
  justifyContent:'center',
  flexDirection:'column',
//   [theme.breakpoints.down("md")]: {
//     maxWidth: "700px",
//     padding: "15px 30px",
//   },
  [theme.breakpoints.down("sm")]: {
    justifyContent:'start',
    maxWidth: "338px",
    marginLeft:'-50px'
   
  },
}));




// // Styled Input with Animated Effect
// const InputContainer = styled(Box)({
//   position: "relative",
//   width: "70%",
//   marginBottom: "12px",


// });

const AnimatedInput = styled(TextField)({
    width: "100%",
    height: "45px",
    backgroundColor: "transparent",
    border: "1px solid rgba(255, 255, 255, 0.6)", // Custom border
    borderRadius: "25px", // Custom border-radius
    color: "white",
    fontSize: "14px",
    padding: "8px",
    "& input, & textarea": {
      paddingLeft: "12px",
      color: "white",
    },
    "&:focus-within": {
      border: "1px solid #ff914d",
      boxShadow: "0px 4px 6px rgba(255, 145, 77, 0.5)",
    },
    "& fieldset": {
      border: "none", // Removes default MUI border
    },
    display: "flex",
  alignItems: "start",
  justifyContent: "center",
  });
  
// Input Label Animation
const InputLabel = styled(Typography)({
  position: "absolute",
  left: "12px",
  top: "10px",
  fontSize: "14px",
  color: "rgba(255, 255, 255, 0.6)",
  transition: "0.3s ease-in-out",
  pointerEvents: "none",
});

// Social Icons with 3D Effect
const SocialIconButton = styled(IconButton)({
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "white",
    margin: "5px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  
    "&:hover": {
      backgroundColor: "#9f8054",
      transform: "translateY(-3px)",
      boxShadow: "0px 6px 15px rgba(255, 145, 77, 0.5)",
    },
  });





  



    // Hover Effect (3D Effect, Scale & Rotation)
    const hoverEffect = keyframes`
    0% { transform: scale(1) rotate(0deg); }
    50% { transform: scale(1.1) rotate(5deg); box-shadow: 0px 6px 12px rgba(255, 255, 255, 0.4); }
    100% { transform: scale(1) rotate(0deg); }
    `;

    // Styled Container for Hook Section
    // const HookContainer = styled(Box)({
    // backgroundColor: "#9f8054",
    // borderRadius: "16px",
    // padding: "20px 40px",
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
    // width:'1076px',
    // zIndex:10

    // });


    const HookContainer = styled(Box)(({ theme }) => ({
        backgroundColor: "#9f8054", // Background Color Matching the Image
        borderRadius: "16px",
        padding: "20px 40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
        width: "100%", 
        maxWidth: "1076px",
        zIndex: 10,
      
        // **Responsive Breakpoints**
        // [theme.breakpoints.down("md")]: {
        //   maxWidth: "700px",
        //   padding: "15px 30px",
        // },
        [theme.breakpoints.down("sm")]: {
          maxWidth: "330px",
          padding: "10px 20px",
          flexDirection: "column",
          textAlign: "center",
         
        },
      }));

    // Styled Box for Each Item
    const HookItem = styled(Box)({
    display: "flex",
    alignItems: "start",
    gap: "12px",
    textAlign: "left",
    color: "#fff",
    });

    // Styled Icon Button with Floating and 3D Effect
    const IconWrapper = styled(IconButton)({
    backgroundColor: "#fff",
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
    animation: `${floatingAnimation} 2s ease-in-out infinite`,
    transition: "0.3s ease-in-out",
    "&:hover": {
    animation: `${hoverEffect} 0.5s ease-in-out`,
    backgroundColor: "#9f8054",
    color: "#fff",
    },
    });


  interface FormData {
      name: string;
      email: string;
      phoneNumber: string;
      gender: string;
      message: string; // Added message property
  }

const Footer = () => {
  const textRef = useRef(null);
    const navigate = useNavigate();
  
  const linksRef = useRef(null);

   const {
      register,
      handleSubmit,
      reset,
      formState: { errors },
    } = useForm<FormData>({
      defaultValues: { gender: "Male" }, 
    });


    // Mutation for API Call
    const mutation = useMutation(createLead, {
    onSuccess: (response: any) => {
      toast.success(response.message || 'Thank you for visiting. Our sales team will contact you soon.'); // Use message from backend
        reset();
     
      },
      onError: () => {
        alert("Something went wrong. Try again!");
      },
    });
  useEffect(() => {
    // GSAP Animation for Description Text
    gsap.to(textRef.current, {
      opacity: 1,
      y: -10,
      duration: 0.1,
      delay: 0.1,
    });


    gsap.to(linksRef.current, {
        opacity: 1,
        duration: 0.8,
        delay: 0.3,
        ease: "power3.out",
      });
  }, []);


  // Form Submission
  const onSubmit = (data: FormData) => {
    const newdata = {
      ...data,
      type: "Customer",
      sourceType: "Online",
      location: "Hyderabad",
      projectName: "LUXOR EXCLUSIVE",
    };
    mutation.mutate(newdata);
  };





  return (
    <Box
    sx={{}}
    >
        

        <FooterContainer>
        <Container maxWidth={false} sx={{ position: "relative", zIndex: 2 , display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <Grid container spacing={4} sx={{ position: "relative", zIndex: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
            {/* LEFT SIDE - Floating Box with Description */}
            <Grid item xs={12} md={3.4} sx={{ display: "flex", flexDirection: "column" ,textAlign: { xs: "center", md: "center" } , justifyContent:'start',alignItems:'start'}}>
                {/* <Logo src={kollalogowhite} alt="Logo" /> */}
                <BackgroundContainer>
                    <img src={kollalogowhite} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" width='100px' />
                </BackgroundContainer>
                <AnimatedText sx={{textAlign: { xs: "start", md: "justify" } ,mt: 6,}}>
                    Admired real estate organizations in Hyderabad. Known for its professional conduct, Kolla Group has garnered appreciation for its commitment to completing their projects without compromising on the quality.
                </AnimatedText>
                <Box sx={{ display: "flex", justifyContent: "start", mt: 2,textAlign:'start' }}>
                    <SocialIconButton onClick={() => window.open("https://wa.me/7995999771", "_blank")}>
                    <WhatsApp />
                    </SocialIconButton>
                    <SocialIconButton onClick={() => window.open("https://www.instagram.com/kolla_group?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==", "_blank")}>
                    <Instagram />
                    </SocialIconButton>
                    <SocialIconButton onClick={() => window.open("https://www.facebook.com/people/KOLLA/61571507684414/", "_blank")}>
                    <Facebook />
                    </SocialIconButton>
                    <SocialIconButton onClick={() => window.open("https://www.linkedin.com/company/kolla_group/", "_blank")}>
                    <LinkedIn />
                    </SocialIconButton>
                    <SocialIconButton onClick={() => window.open("https://www.youtube.com/@KOLLA_Group", "_blank")}>
                    <YouTube />
                    </SocialIconButton>
                    <SocialIconButton onClick={() => window.open("https://x.com/kollagroup", "_blank")}>
                    <XIcon />
                    </SocialIconButton>
                </Box>
            </Grid>

               {/* Middle - Quick Links with Icons */}
               <Grid item xs={12} md={2.2} sx={{ display: "flex", flexDirection: "column" ,textAlign:'justify', justifyContent:'start',alignItems:{md:'center',xs:'start'}}}>
              <QuickLinksContainer ref={linksRef}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 ,color:'white'}}>
                  Quick Links
                </Typography>
                {quickLinks.map((link, index) => (
                  <QuickLink href={link.url} key={index}>
                    {link.icon}
                    {link.title}
                  </QuickLink>
                ))}
              </QuickLinksContainer>
            </Grid>

             <Grid item xs={12} md={2.5}>
                <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 1 }}>
                  CALL US
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <PhoneIcon sx={{ color: 'primary.main', mr: 1 }} />
                  <Typography
                    variant="body1"
                    sx={{ color: 'primary.main', fontWeight: '600', cursor: 'pointer' }}
                    onClick={() => window.open('https://wa.me/917995999771', '_blank')}
                  >
                    +91 799 599 9771
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <EmailIcon sx={{ color: 'primary.main', mr: 1 }} />
                  <Typography
                    variant="body1"
                    sx={{ color: 'primary.main', fontWeight: '600', cursor: 'pointer' }}
                    onClick={() => window.open('mailto:contact@kollagroup.com', '_blank')}
                  >
                    contact@kollagroup.com
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
                  <LocationOnIcon sx={{ color: 'primary.main', mr: 1, mt: 0.5 }} />
                  <Typography variant="body2" sx={{ color: 'gray', lineHeight: 1.85 }}>
                    <strong>Location : </strong>
                    CHANDA NAGAR, Miyapur, Hyderabad-500133
                  </Typography>
                </Box>
              </Grid>

            {/* RIGHT SIDE - GSAP Animated Form */}
            <Grid item xs={12} md={3.5} sx={{}}>
  <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
    {/* Name */}
    <InputContainer>
      <InputIcon>
        <Person />
      </InputIcon>
      <StyledInput
        variant="outlined"
        placeholder="Name"
        {...register("name", { required: "Name is required" })}
        error={!!errors.name}
        helperText={errors.name?.message}
      />
    </InputContainer>

    {/* Email */}
    <InputContainer>
      <InputIcon>
        <Email />
      </InputIcon>
      <StyledInput
        variant="outlined"
        placeholder="Email"
        {...register("email", {
          required: "Email is required",
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        })}
        error={!!errors.email}
        helperText={errors.email?.message}
      />
    </InputContainer>

    {/* Phone Number */}
    <InputContainer>
      <InputIcon>
        <TbPhoneCall />
      </InputIcon>
      <StyledInput
        variant="outlined"
        placeholder="Phone Number"
        {...register("phoneNumber", {
          required: "Phone number is required",
          pattern: /^[6789]\d{9}$/,
        })}
        error={!!errors.phoneNumber}
        helperText={errors.phoneNumber?.message}
      />
    </InputContainer>



    {/* Message */}
    {/* <InputContainer>
      <InputIcon>
        <Email />
      </InputIcon>
      <StyledInput
        variant="outlined"
        placeholder="Message"
        multiline
        rows={3}
        {...register("message", {
          required: "Message is required",
          minLength: { value: 10, message: "Message must be at least 10 characters" },
        })}
        error={!!errors.message}
        helperText={errors.message?.message}
      />
    </InputContainer> */}

    {/* Submit Button */}
    <Button
      type="submit"
      variant="contained"
      sx={{ mt: 0, width: "80%", bgcolor: "#9f8054" }}
    >
      Submit
    </Button>
  </form>
</Grid>
            </Grid>
        </Container>

        <Box
        >
            
        </Box>
        </FooterContainer>
             <Divider sx={{ my: 0, bgcolor: 'gray' }} />
                <Box sx={{ textAlign: 'center', color: 'gray', my: 3 }}>
                  <Typography variant="body2">
                    © {new Date().getFullYear()} <b>Kolla Group</b>. All rights reserved. 
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <Link
                      onClick={() => navigate('/privacy-policy')}
                      sx={{ color: 'gray', textDecoration: 'none', cursor: 'pointer', '&:hover': { color: 'white' } }}
                    >
                      Designed by{' '}
                      <Link
                        href="https://dezignshark.com"
                        target="_blank"
                        sx={{ color: 'gray', textDecoration: 'none', '&:hover': { color: 'white' } }}
                      >
                        <b>Dezign Shark</b>
                      </Link>
                      {' | '}
                      <Link
                        onClick={() => navigate('/privacy-policy')}
                        sx={{
                          color: 'gray',
                          textDecoration: 'none',
                          cursor: 'pointer',
                          '&:hover': { textDecoration: 'underline' },
                        }}
                      >
                        Privacy Policy
                      </Link>
                    </Link>
                  </Typography>
        
                </Box> 
                
           </Box>
  );
};

export default Footer;





















//                    <HookContainer sx={{
//                      position: "absolute",
//                      top:{ md:'-13%', xs:'-14%' },
//                      left:'15%',
//                      width : '70%',
//                      }}>
//             <Grid container spacing={4} justifyContent="center" alignItems="center">
//             <Grid item xs={12} md={4}>
//                 <HookItem>
//                 <IconWrapper>
//                     <LocationOn fontSize="large" color="primary" />
//                 </IconWrapper>
//                 <Box>
//                     <Typography variant="body2" sx={{ fontWeight: "bold" ,color:'white'}}>
//                     Address
//                     </Typography>
//                     <Typography variant="caption" color="white">KMR Estates & Builders Pvt. Ltd.
//                                         KOLLA Developers and Builders Pvt. Ltd.
//                             WINCON Housing Pvt. Ltd.
//                     </Typography>
//                 </Box>
//                 </HookItem>
//             </Grid>

//             {/* Email */}
//             <Grid item xs={12} md={4}>
//                 <HookItem>
//                 <IconWrapper>
//                     <Email fontSize="large" color="primary" />
//                 </IconWrapper>
//                 <Box>
//                     <Typography variant="body2" sx={{ fontWeight: "bold" ,color:'white'}}>
//                     Send Email
//                     </Typography>
//                     <Link href="mailto:contact@kollagroup.com" sx={{ color: "white", textDecoration: "none" }}>
//                         <Typography variant="caption">contact@kollagroup.com</Typography>
//                     </Link>
                   
//                 </Box>
//                 </HookItem>
//             </Grid>

//             {/* Emergency Call */}
//             <Grid item xs={12} md={4}>
//                 <HookItem>
//                 <IconWrapper>
//                     <Phone fontSize="large" color="primary" />
//                 </IconWrapper>
//                 <Box>
//                     <Typography variant="body2" sx={{ fontWeight: "bold",color:'white' }}>
//                     Call Emergency
//                     </Typography>
//                     <Link href="tel:+916309994444" sx={{ color: "white", textDecoration: "none" }}>
//                         <Typography variant="caption">+91-6309994444</Typography>
//                     </Link>
//                 </Box>
//                 </HookItem>
//             </Grid>
//             </Grid>
//             </HookContainer>